<template>
    <div id="pp">
        <div class="nav-color-track secondary-background"></div>
        <div class="pp-text-block">
            <div class="container">
                <h2 class="position-relative m-title">Privacy Policy</h2>
                <div class="spacer-mm"></div>
                <div class="spacer-mm"></div>
                <h3>Notice of submitting written complaints of service users</h3>
                <div class="spacer-sm"></div>
                <p>In accordance with the provisions of Art. 6. St.1 item 3. Of the Law on Provision of Tourism Services NN no. 130/17 a consumer’s written complaint may be submitted via:</p>
                <ul>
                    <li>email: <a href="mailto: info@katrinadimaladel.com">info@katarinadimaladel.com</a></li>
                </ul>
                <p>The received complaint of the service, user will be notiﬁed in writing without delay, the receipt of the complaint will be conﬁrmed, and the objection will be answered in writing within 15 days from the day of receipt of the complaint.</p>
            </div>
        </div>
        <div class="position-absolute" style="bottom: 0; left: 0; width: 100%;">
            <Footer></Footer>
        </div>
    </div>
</template>

<script>
import Footer from "../modules/Footer";

export default {
    name: "PrivacyPolicy",
    components: {Footer}
}
</script>

<style scoped>
#pp {
    width: 100%;
    height: 100vh;
    overflow-x: hidden;
}
.nav-color-track {
    width: 100%;
    height: 66px;
}
.pp-text-block ul {
    padding-left: 50px;
}
.pp-text-block ul li, .pp-text-block ul li a {
    color: rgb(225, 216, 191);
    text-transform: lowercase!important;
    transition: color 300ms ease-out;
}

.pp-text-block ul li a:hover {
    color: #0C0C0C!important;
}
@media (min-width: 494px) {
    #pp .pp-text-block .container .spacer-mm {
        height: 40px;
    }
    .pp-text-block {
        padding-top: 60px;
    }
    .pp-text-block p {
        line-height: 40px;
    }
}
@media (max-width: 494px) {
    #pp .pp-text-block .container .spacer-mm {
        height: 10px;
    }
    .pp-text-block {
        padding-top: 50px;
    }
    .pp-text-block p {
        line-height: 24px;
    }
}
</style>
